import { ProjectDevelopmentStructure } from '../../../components';
import { ENGINEERING_SYSTEMS_STORAGE_PATH } from '../../../engineering-systems-constants';
import { FILTER_DEVELOPMENT_ID } from '../../filter-systems-constants';

export const COMPOSITION_LIST_WITHOUT_WATER_ANALYSIS = [
  '— выезд специалиста на объект;',
  '— заполнение технического задания;',
  '— подбор оборудования и составление сметы;',
  '— замер помещения и технических коммуникаций;',
];

export const COMPOSITION_LIST_WITH_WATER_ANALYSIS = [
  ...COMPOSITION_LIST_WITHOUT_WATER_ANALYSIS,
  '— забор пробы воды и анализ в аккредитованной лаборатории по 14 показателям.',
];

export const FILTER_DEVELOPMENT_PROJECT: ProjectDevelopmentStructure = {
  title: 'Услуга подбора системы водоочистки',
  description:
    'Монтаж и\u00A0оборудование оплачиваются отдельно. Стоимость монтажа рассчитывается по\u00A0смете, составленной для эскизного проекта или рабочей документации.',
  id: FILTER_DEVELOPMENT_ID,
  compositionList: [],
  schedule: '1 — 7 рабочих дней',
  fixedPrice: true,
  exampleHref: `${ENGINEERING_SYSTEMS_STORAGE_PATH}sistemy-filtracii-vody-dlya-zagorodnogo-doma-primer-proektnoy-smety.pdf`,
};
